import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-return-invoice-modal',
    templateUrl: 'return-invoice-modal.component.html',
    styleUrls: ['return-invoice-modal.component.scss'],
    standalone: false
})
export class ReturnInvoiceModalComponent {
  @ViewChild('content') private template: TemplateRef<any>;

  returnRemark: string;
  @Output() returnEvent = new EventEmitter<string>();

  private modalRef: NgbModalRef;

  constructor(public modalService: NgbModal) {
  }

  open() {
    this.modalRef = this.modalService.open(this.template, { backdrop: 'static', keyboard: false });
  }

  close() {
    this.modalRef.close();
  }

  returnToAccounting() {
    this.returnEvent.emit(this.returnRemark);
    close();
  }
}
